import { useTranslation } from 'react-i18next';

import styles from './InvalidMatrixInfo.module.scss';

export const InvalidMatrixInfo = () => {
  const { t } = useTranslation(['configErrors']);

  return <div className={styles.invalidMatrixInfo}>{t('configErrors:invalid_matrix_configuration')}</div>;
};
